<script setup>
import {useMatchedBetStore} from "@/stores/MatchedBetStore";
import {computed} from "vue";

const matchedBetStore = useMatchedBetStore()

const haveEvent = computed(() => {
  return matchedBetStore.oddsmatcherData.eventDescription !== null &&
         matchedBetStore.oddsmatcherData.eventStart !== null &&
         matchedBetStore.oddsmatcherData.outcome !== null;
});


const formatDate = (dateString) => {
  const options = {year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false};
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-UK', options).format(date);
};
</script>

<template>
  <div class="bet-calc-container-header">
    <div v-if="haveEvent">
      You have a matched bet on {{ matchedBetStore.oddsmatcherData.eventDescription }}!
      It starts at {{ formatDate(matchedBetStore.oddsmatcherData.eventStart) }}.
      You are betting on  <strong>{{ matchedBetStore.oddsmatcherData.outcome }}.</strong>
      If you want to find a different matched bet you can do that <router-link :to="{ name: 'oddsmatcher' }">here</router-link>
    </div>

    <div v-else>
      Need to find a matched bet? Get one from oddsmatcher <router-link :to="{ name: 'oddsmatcher' }">here</router-link>
    </div>
  </div>

</template>

<style scoped>
.bet-calc-container-header {
  margin-block: 1rem;
}
</style>